import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import FeaturesArray from "./FeaturesArray";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpload from "components/shared/ImageUpload";
import { Input, Textarea } from "components/shared/FormComponents";

const Section = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);

  const [features, setFeatures] = useState([]);

  const [lightModeCharacter, setLightModeCharacter] = useState({
    preview: null,
    path: "",
  });
  const [darkModeCharacter, setdarkModeCharacter] = useState({
    preview: null,
    path: "",
  });

  const [sectionActivition, setSectionActivition] = useState(true);
  const sectionActivitionHandler = () =>
    setSectionActivition(!sectionActivition);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "features",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (section?.features) {
      // const updatedSections = [];

      // Object.entries(section?.features).forEach(([key, section]) =>  {

      //   section.id = v4();
      //   section.image = process.env.REACT_APP_URL + section?.image.slice(1);
      //   updatedSections.push(section)
      // });
      reset({
        heading: section?.heading,
        characterRole: section?.characterRole,
        characterName: section?.characterName,
        characterDescription: section?.characterDescription,
      });
      setSectionActivition(section?.sectionActivition);

      setLightModeCharacter({
        preview: null,
        path: section?.lightModeCharacter,
      });
      setdarkModeCharacter({
        preview: null,
        path: section?.darkModeCharacter,
      });
      setFeatures(section?.features);
    }
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // data.features = features.map(feature => {
    //   return { ...feature, image: `/uploads/${feature.image?.split("/").at(-1)}` }
    // })
    if (!lightModeCharacter?.path || !darkModeCharacter?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.lightModeCharacter = lightModeCharacter?.path;
    data.darkModeCharacter = darkModeCharacter?.path;
    data.features = features;
    data.sectionActivition = sectionActivition;

    dispatch(
      editSection({ slug: "features", page: "home", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"features"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                {/* image  */}
                <Col lg={6} xs={6}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"lightModeCharacter"} />
                    </h5>
                    <ImageUpload
                      selectedImage={lightModeCharacter}
                      setSelectedImage={setLightModeCharacter}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={6}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"darkModeCharacter"} />
                    </h5>
                    <ImageUpload
                      selectedImage={darkModeCharacter}
                      setSelectedImage={setdarkModeCharacter}
                    />
                  </div>
                </Col>
              </Row>

              {/* heading  */}
              <Row>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="heading.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="heading.en"
                    register={register}
                    errors={errors}
                    dir="ltr"
                  />
                </Col>
              </Row>
              <div className="card-head">
                <h4>
                  <FormattedMessage id={"character-info"} />
                </h4>
              </div>
              <Row>
                <Col lg={6} xs={12}>
                  <Input
                    langId="characterName"
                    name="characterName.ar"
                    register={register}
                    errors={errors}
                    rules={{ required: true }}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="characterName"
                    name="characterName.en"
                    register={register}
                    errors={errors}
                    rules={{ required: true }}
                    dir="ltr"
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="characterRole"
                    name="characterRole.ar"
                    register={register}
                    errors={errors}
                    rules={{ required: true }}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="characterRole"
                    name="characterRole.en"
                    register={register}
                    errors={errors}
                    rules={{ required: true }}
                    dir="ltr"
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="characterDescription"
                    name="characterDescription.ar"
                    register={register}
                    errors={errors}
                    rules={{ required: true }}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="characterDescription"
                    name="characterDescription.en"
                    register={register}
                    errors={errors}
                    rules={{ required: true }}
                    dir="ltr"
                  />
                </Col>
              </Row>
              <Col md={4} xs={12}>
                <div className="only-radio toggle-switch mb-5">
                  <label className="switch-label" htmlFor="sectionActivition">
                    <FormattedMessage id="sectionActivition" />
                  </label>
                  <label className="switch" htmlFor="sectionActivition">
                    <input
                      id="sectionActivition"
                      type="checkbox"
                      checked={sectionActivition}
                      onChange={sectionActivitionHandler}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </Col>
              <Col xl={12}>
                <FeaturesArray features={features} setFeatures={setFeatures} />

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
